import {Service} from '@s-ui/domain'

class GetSearchUrlAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {fromSearchJSONToUrlVOMapper} deps.mapper
   * @param {GetUrlService} deps.service
   */
  constructor({config, mapper, getUrlService, searchRequestValueObjectFactory}) {
    super({config, mapper, getUrlService})

    this._config = config
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._mapper = mapper
    this._getUrlService = getUrlService
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
  }

  /**
   * @param {Object} params
   * @param {Number} data.page
   * @param {String} data.sortBy
   * @param {Number} data.sortOrder
   * @param {Number} data.categoryId
   * @param {Number} data.offerTypeId
   * @param {Object} data.filters,
   * @return {Promise<Object, Error>} search params object
   * @return {Object<url: String>}
   */
  async execute({
    page = 1,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    categoryId,
    offerTypeId,
    ...filters
  } = {}) {
    const searchRequestObjectVO = this._searchRequestValueObjectFactory({
      page,
      sortBy,
      sortOrder,
      categoryId,
      offerTypeId,
      ...filters
    })

    const searchQuery = await this._mapper.setParams({...searchRequestObjectVO.toJSON()}).map()

    return this._getUrlService.execute({
      pageName: 'ADS_LIST',
      params: {categoryId, offerTypeId},
      query: searchQuery
    })
  }
}

export default GetSearchUrlAdsService
